import { SelectInput } from '../baseInputs'

type ColourOption = {
  label: string
  value?: string
}

type Props = {
  grade: string
  colours?: ColourOption[]
  helper?: string
  optional?: boolean
}

const Colour = ({ helper, grade, colours, optional }: Props) => {
  const name = 'colours'
  const label = 'Colour'

  if (!grade || !colours || colours.length === 0) {
    return null
  }

  const options = colours.map((colour) => ({
    label: colour.label,
    value: colour.value || colour.label,
  }))

  return (
    <SelectInput
      name={name}
      label={label}
      options={options}
      helper={helper}
      optional={optional}
    />
  )
}

export default Colour
